const FrameRowArray = (props) => {
  const item = props.item;
  // const { item } = props;

  const handleChange = (id, field, newValue) => {
    props.onChange(id, field, newValue);
  };

  return (
    <div className="layersRow">
      <label htmlFor={item.id}>{item.descr}</label>
      <input
        id={item.id}
        type="text"
        value={item.value}
        onChange={(e) => handleChange(item.id, 'value', e.target.value)}
      />
    </div>
  );
};

export default FrameRowArray;
